import { ApplicationUser, RecentlyPlayedWithUser } from "app/core/users/users.types";
import { Course } from "../courses/course.types";
import { Member } from "../members/members.types";
import { PlayerTypePrice } from "../prices/price.types";
import { DateTime } from "luxon";

export interface PlayerSlot {
  id: string;
  type: PlayerSlotType;
  userId?: string;
  displayName: string;
  profileImageUrl?: string;
  isCurrentUser: boolean;
  isGuest: boolean;
  isMember: boolean;
  isAffiliated: boolean;
  playerType?: BasicPlayerType;
  price?: PlayerTypePrice;
  cellphoneNumber?: string;
  members: Member[];
}

export interface BasicPlayerType {
  id: number;
  memberTypeId: number | null;
  description: string;
  affiliation: PlayerAffiliation;
}

export enum PlayerAffiliation {
  Member = 0,
  NonAffiliated = 1,
  Public = 2
}

export interface PlayerTypeSelectionData {
  availablePlayerTypes: BasicPlayerType[];
  currentCourseId: number;
  userMemberships: Member[];
  playerIndex: number;
  selectedPlayerType: BasicPlayerType | null;
}

export interface PlayerTypeSelectionResult {
  playerType: BasicPlayerType;
  playerIndex: number;
}

export interface PlayerSelectionResult {
  type: 'user' | 'guest';
  user?: ApplicationUser | RecentlyPlayedWithUser;
  guestData?: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
  };
}

export enum HoleType {
  NineHoles = 9,
  EighteenHoles = 18
}

export interface GolfCartSelectionData {
  courseId: number;
  courseName: string;
  nineHolePrice: number;
  eighteenHolePrice: number;
  availablePlayers: PlayerSlot[]; // Only non-guest players
  selectedHoleType: HoleType,
}

export interface GolfCartSelection {
  holeType: HoleType;
  price: number;
  payingPlayers: PlayerSlot[];
  pricePerPlayer: number;
}

export interface Cart {
  course: Course;
  slots: PlayerSlot[];
  holeType: HoleType;
  golfCarts: any;
}

export type PlayerSlotType = 'EMPTY' | 'CURRENT_USER' | 'OTHER_USER' | 'GUEST';

export interface CreateBooking {
  teeOffTime: Date;
  noOfCarts: number;
  isBackNine: boolean;
  applySpecial: boolean;
  courseId: number;
  users: CreateBookingUser[];
  guests: CreateBookingGuest[];
  invitedUsers: CreateBookingInvitedUser[];
  userIdsToPay: string[];
  isNineHoles: boolean;
  isEighteenHoles: boolean;
  useCredits: boolean;
  usePackageRound: boolean;
  fromClubBookingId: number | null;
  overrideReturnUrl: string | null;
}

export interface CreateBookingUser {
  userId: string;
  cartNo: number | null;
  playerTypeId: number;
}

export interface CreateBookingGuest {
  firstName: string;
  lastName: string;
  age: number;
  cartNo: number | null;
  playerTypeId: number;
}

export interface CreateBookingInvitedUser {
  name: string;
  cellNumber: string;
  userId: string;
  playerTypeId: number;
}

export interface CreateBookingResponse {
  id: number;
  creatorPayment: Payment | null;
}

export interface Payment {
  id: string;
  url: string | null;
  status: PaymentStatus;
  bookingId: number;
  referenceId: string;
  payGateResponse: string | null;
  payGatePaymentId: string | null;
  amountPaid: number | null;
  convenienceFee: number;
}

export enum PaymentStatus {
  AwaitingPayment = 1,
  Success = 2,
  Failed = 3,
  Cancelled = 4,
  SuccessOverdue = 5
}